var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 60,
    height: 60,
    rx: 10,
    fill: "#ffaa8c",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Location",
    "data-name": "Iconly Two-tone Location",
    transform: "translate(17.143 13.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-8",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33958",
    "data-name": "Path 33958",
    d: "M1883.639,1702.209a13.163,13.163,0,0,1,26.326.083v.149a19.421,19.421,0,0,1-5.962,12.514,34.6,34.6,0,0,1-6.156,5.069,1.6,1.6,0,0,1-2.086,0,33.99,33.99,0,0,1-8.66-8.109,16.862,16.862,0,0,1-3.461-9.662Z",
    transform: "translate(-1883.639 -1689.088)",
    fill: "none",
    stroke: "#fa8b94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_740",
    "data-name": "Ellipse 740",
    cx: 4.219,
    cy: 4.219,
    r: 4.219,
    transform: "translate(8.946 9.156)",
    fill: "none",
    stroke: "#fa8b94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b590f2e70caa8037ea6b379257adc6f1.svg";
export { ForwardRef as ReactComponent };